import { observable, action, computed } from 'mobx';
import { ProductSku, IProductSkuMap } from '../domain/entities/ProductSku';
import { ICoreProduct, ProdcatApiSdk, IParamsById } from '../../api/ProdcatApiSdk';
import { ConfigStore } from '../../service-setup/ConfigStore';
import { ISku } from '../domain/entities/Sku';

export interface IProductSkuRepository {
    prodcatApiSdk: ProdcatApiSdk;
    configStore: ConfigStore;
}

export class ProductSkuRepository {
    @observable public productData: ICoreProduct[];

    private prodcatApiSdk: ProdcatApiSdk;
    private configStore: ConfigStore;

    constructor(productSkuStoreConfig: IProductSkuRepository) {
        this.prodcatApiSdk = productSkuStoreConfig.prodcatApiSdk;
        this.configStore = productSkuStoreConfig.configStore;
    }

    @action
    public clearStore = () => {
        this.productData = [];
    };

    @action
    public setProductData = (data: ICoreProduct[]) => {
        this.productData = data;
    };

    @computed
    public get products(): IProductSkuMap {
        return this.productData && this.productData.reduce(this.mapProductDataById, {});
    }

    public getProductData = async (
        paramsById: IParamsById,
        query?: string
    ): Promise<IProductSkuMap> => {
        try {
            const products = await this.prodcatApiSdk.getProducts(paramsById, query);
            this.setProductData(products);
        } catch (error) {
            this.setProductData([]);
        }

        return this.products;
    };

    private mapProductDataById = (data: IProductSkuMap, product: ICoreProduct) => {
        const getProducts = (skuData: IProductSkuMap, sku: ISku) => {
            const { skus, ...productDetails } = product;
            const newSku = {
                ...productDetails,
                ...sku
            };

            return {
                ...skuData,
                [sku.sku_id]: ProductSku.fromJSON(newSku, this.configStore.config.currency)
            };
        };

        const skusData = product.skus.items.reduce(getProducts, {});

        return { ...data, ...skusData };
    };
}
